import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class GearsAnimationStatus {

  private animation$: Subject<boolean>;

  constructor() {
    this.animation$ = new Subject();
  }

  setGearsAnimation(animation: boolean) {
    this.animation$.next(animation);
  }

  getGearsAnimation(): Observable<boolean> {
    return this.animation$.asObservable();
  }
}
